module.exports = __webpack_public_path__ + "static/media/unsplash.314e918a.png";